import { LpcuDetailsLocation } from './lpcu-details-location.model';
import { LpcuDetailsLpcuStatus } from './lpcu-details-lpcu-status.model';
import { LpcuDetailsLpcu } from './lpcu-details-lpcu.model';

export class LpcuDetails
{

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            if (json.Location) this.Location = new LpcuDetailsLocation(json.Location);
            if (json.Device) this.Device = new LpcuDetailsLpcu(json.Device);
            if (json.DeviceStatus) this.DeviceStatus = new LpcuDetailsLpcuStatus(json.DeviceStatus);
        }
    }

    IsOn: boolean;
    Location: LpcuDetailsLocation;
    Device: LpcuDetailsLpcu;
    DeviceStatus: LpcuDetailsLpcuStatus;
    Temperature: number;                    // Temperature in Celsius

    get temperatureString(): string
    {
        return `${this.Temperature * 1.8 + 32} F   (${this.Temperature} C)`;
    }

    get outletStatus(): string {
        return (this.IsOn) ? 'Auto' : 'Off';
    }
}
